import { Chapter } from "./Chapter";
import { AlphabetizedCollection } from "./alphabetized-collection";

export class Entry {

    public id: number;
    public title: string;
    public minimal: boolean;
    public image_url: string;
    public parents: Entry[];
    public root_chapter: Chapter;

    public static createMany(data: any[]): Entry[] {
        let entries: Entry[] = [];
        for (let item of data) {
            entries.push(Entry.createOne(item));
        }
        return entries;
    }

    public static createOne(data: any): Entry {
        let entry = new Entry();
        entry.fill(data);
        return entry;
    }

    public static sortByTitle(entries: Entry[]) {
        if (!entries) return null;

        return entries.sort((a, b) => {
            const title_a = AlphabetizedCollection.removeSpecialCharsAndLowercase(a.title);
            const title_b = AlphabetizedCollection.removeSpecialCharsAndLowercase(b.title);

            if (title_a < title_b) return -1;
            if (title_a > title_b) return 1;
            return 0;
        });
    }

    public fill(data: any) {
        this.id = data.id || null;
        this.title = data.title || null;
        this.minimal = data.minimal || false;
        this.image_url = data.image_url || null;
        this.parents = data.parents ? Entry.createMany(data.parents) : null;
        this.root_chapter = data.root_chapter ? Chapter.createOne(data.root_chapter) : null;
    }

}



// WEBPACK FOOTER //
// ./src/models/entry.ts